/**
 * Пикер иконок — сетка иконок из пака БД (GET /v1/icons) с выбором
 * (правки Артёма 2026-06-17). Используется в форме удобства (выбор/смена
 * иконки). Выбранная подсвечивается.
 */
import { DbIcon } from '../../shared/nav/DbIcon.js';
import { useIcons } from './useAmenities.js';

export interface IconPickerProps {
  /** id выбранной иконки (или null — без иконки). */
  value: string | null;
  /** Сменить выбор. null = снять иконку. */
  onChange: (iconId: string | null) => void;
}

export function IconPicker({ value, onChange }: IconPickerProps): JSX.Element {
  const iconsQ = useIcons();
  const icons = iconsQ.data ?? [];

  if (iconsQ.isLoading) {
    return <p className="hsc-input__hint">Загружаем иконки…</p>;
  }
  if (iconsQ.isError) {
    return (
      <p role="alert" className="fleet-card__err">
        Не удалось загрузить иконки.
      </p>
    );
  }

  return (
    <div className="amenity-iconpicker" data-testid="amenity-icon-picker">
      <button
        type="button"
        className={`amenity-iconpicker__item${value === null ? ' is-active' : ''}`}
        onClick={() => onChange(null)}
        aria-pressed={value === null}
        title="Без иконки"
        data-testid="amenity-icon-none"
      >
        —
      </button>
      {icons.map((ic) => (
        <button
          key={ic.id}
          type="button"
          className={`amenity-iconpicker__item${value === ic.id ? ' is-active' : ''}`}
          onClick={() => onChange(ic.id)}
          aria-pressed={value === ic.id}
          title={ic.label}
          data-testid={`amenity-icon-${ic.key}`}
        >
          <DbIcon icon={ic} size={22} />
        </button>
      ))}
    </div>
  );
}
